import { handleIpBan } from '@/utils/ipBan'
 
import axios from 'axios';
import { getToken } from '@/utils/auth'
import { MessageBox } from 'element-ui'
import store from '@/store'
import { encryptRequestConfig, clearEncryptionKeyCache } from '@/utils/requestCrypto'

import Vue from 'vue'
// 基本配置
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API||'http://192.168.1.27:8080', // 根据实际情况修改API地址
  timeout: 60000 // 设置超时时间，单位为ms
});
 

// 请求拦截器
instance.interceptors.request.use(async config => {
  // 在发送请求之前做些什么，比如添加token
  const token = getToken(); // 从auth工具中获取token

  if (token) {
    // 如果token存在，则将其添加到请求头中
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  // 注意：没有 token 时不主动登出，由后端决定是否需要认证

  // 添加多语言支持
  const language = store.getters.language || 'en';
  config.headers['Accept-Language'] = language;

  // 返回配置对象，以便继续发送请求
  return encryptRequestConfig(config);
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});  
 
//响应拦截处理  响应拦截器：包含两个函数（一个是成功返回的函数，一个是失败的返回的函数）
instance.interceptors.response.use(async res => {
    if (handleIpBan(res)) return Promise.reject(new Error('IP_BANNED'));
    if (res.config.downloadBlob) {
      const type = String(res.headers['content-type'] || '').toLowerCase();
      // RuoYi can return a JSON 401 with HTTP 200. Keep it in the shared login flow.
      if (type.includes('json')) {
        const data = JSON.parse(await res.data.text());
        if (data.code === 403) throw Object.assign(new Error(data.msg || 'Download forbidden'), { code: 403 });
        return data;
      }
      if (!type.includes('application/pdf')) throw new Error('File unavailable');
      return { code: 200, data: res.data };
    }
    if (res.headers['content-type'] === 'application/pdf;charset=UTF-8') {
      // 处理 PDF 响应
      const blob = new Blob([res.data], { type: 'application/pdf;charset=UTF-8' });
      const url = window.URL.createObjectURL(blob);
      // 例如，你可以在这里打开一个新的窗口或标签页来显示 PDF
      window.open(url);
      return

      // const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', 'filename.pdf'); // 设置下载的文件名
      // document.body.appendChild(link);
      // link.click(); // 触发下载
      // document.body.removeChild(link);
      // window.URL.revokeObjectURL(url);
    }
    // 处理 Excel 报价单下载
    if (res.headers['content-type'] && res.headers['content-type'].indexOf('spreadsheetml') !== -1) {
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      let filename = 'quote.xlsx';
      const disposition = res.headers['content-disposition'];
      if (disposition) {
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }
      }
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return
    } 
    // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
    // res 是所有相应的信息
    return res.data
}, err => {
  const response = err.response
  if (handleIpBan(response)) return Promise.reject(err)
  const encryptionError = response && response.headers && response.headers['x-encryption-error']
  const expiredKey = encryptionError === 'ENCRYPTION_KEY_EXPIRED' ||
    (response && response.data && response.data.msg === 'ENCRYPTION_KEY_EXPIRED')
  if (expiredKey && response.config && !response.config.__encryptionRetried) {
    clearEncryptionKeyCache()
    const retryConfig = response.config
    retryConfig.__encryptionRetried = true
    retryConfig.data = retryConfig.__plainData
    retryConfig.params = retryConfig.__plainParams
    delete retryConfig.headers['X-Encrypted-Payload']
    delete retryConfig.headers['Content-Type']
    return instance(retryConfig)
  }

  if (response) {
    if (response.status === 401) {
      store.dispatch('user/FedLogOut')
      return { code: 401, msg: 'You have not logged in or your login has expired.' };
    }
    switch (response.status) {
      case 403:
        break
      case 404:
        break
      case 500:
        break
    }
  } else {
    if (!window.navigator.onLine) {
      //断网处理：跳转到断网页面
      return
    }
  }
  // 服务器响应发生错误
  return Promise.reject(err)
})
 
 
// 登录弹窗防重复：同一时间只显示一个登录过期提示
let isShowingLoginDialog = false

// 响应拦截器
instance.interceptors.response.use(async response => {
  const data = response;

  if (data && data.code !== 200) { // 根据接口返回的状态码判断是否有错误
       if(data && data.code === 401){
        // 如果已有登录弹窗在显示，直接 reject，不再弹出新弹窗
        if (isShowingLoginDialog) {
          return Promise.reject(new Error(data.msg||data.message));
        }
        isShowingLoginDialog = true;
        try {
          await new Promise(resolve => {
            const vm = new Vue() // 创建临时实例
            MessageBox.confirm('You have not logged in or your login has expired. Please log in first.', 'System Tips', { confirmButtonText: 'Login', cancelButtonText: 'cancel', type: 'warning' }).then(() => {
              vm.$login.show({})
              resolve()
            }).catch(() => {
              // 用户点击取消时调用登出操作
              store.dispatch('user/LogOut')
              // window.location.reload()
              resolve()
            });
          })
        } finally {
          isShowingLoginDialog = false
        }
        return Promise.reject(new Error(data.msg||data.message));
      }
      // alert(`Error code ${data.code}: ${data.message}`); // 自定义错误提示
      return Promise.reject(new Error(data.msg||data.message));
  } else {
      return data;
  }

}, error => {
  return Promise.reject(error);
});
 
export default instance;
